/**
 * Main Grid & next block tray
 */

import { GameBoardBlockTray } from "./BlockTray/GameBoardBlockTray";
import { GameBoardGrid } from "./Grid/GameBoardGrid";
import './GameBoard.css';
import { useState } from "react";

export function GameBoard( { params } ){
   
    return (
        <div className='GameBoard'>
            <GameBoardGrid params={params}></GameBoardGrid>
            <GameBoardBlockTray></GameBoardBlockTray>
        </div>
    );
}